'use client';

import { Portal } from '@common/components';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';

import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';

import { useBottomCTAAnimation } from './useBottomCTAAnimation';

export interface CartBottomCTABaseProps {
  children: ReactNode;
  toastContent?: ReactNode;
  isHidden?: boolean;
  className?: string;
}

export const CartBottomCTABase = ({
  children,
  toastContent,
  isHidden = false,
  className,
}: CartBottomCTABaseProps) => {
  const { isBottomVisible, isToastActive, displayToastContent } =
    useBottomCTAAnimation({ isHidden, toastContent });

  return (
    <Portal renderTo={getMainWrapperElement}>
      {/* 바텀 CTA 컨테이너 */}
      <div
        className={cn(
          'fixed inset-x-0 bottom-0 z-20 transition-transform duration-300 ease-out',
          isBottomVisible ? 'translate-y-0' : 'translate-y-full',
          className,
        )}
      >
        {/* 혜택 토스트 - 흰색 영역 뒤에서 올라오는 애니메이션 */}
        <div
          className={cn(
            'absolute inset-x-0 -z-10 rounded-t-medium bg-Gray-black px-16 py-8 transition-all duration-300 ease-out flex-center',
            isToastActive ? 'bottom-full translate-y-20' : 'bottom-0',
          )}
        >
          <div className="mb-20">{displayToastContent}</div>
        </div>

        {/* 메인 콘텐츠 (기부 금액 + 버튼) */}
        <div className="rounded-t-medium bg-Gray-white pb-[calc(12px+var(--safe-area-bottom,0px))] shadow-[0px_-8px_30px_0px_rgba(255,255,255,0.25)]">
          {children}
        </div>
      </div>
    </Portal>
  );
};
